export interface SanitySlug {
  current: string;
}

export interface ImageAsset {
  url: string;
  size: number;
  metadata: ImageAssetMetadata;
}

export interface ImageAssetMetadata {
  dimensions: ImageAssetDimensions;
}

export interface ImageAssetDimensions {
  aspectRatio: number;
  height: number;
  width: number;
}
export interface SanityImageAsset {
  value: ImageAsset;
  ref: string;
  _ref: string;
}

export interface SanityImage {
  asset: SanityImageAsset;
  crop: SanityImageCrop;
  hotspot: SanityImageHotspot;
}

export interface SanityImageCrop {
  top: number;
  bottom: number;
  left: number;
  right: number;
}

export interface SanityImageHotspot {
  x: number;
  y: number;
  height: number;
  width: number;
}

export interface SanityFileAsset {
  _ref: string;
  asset: FileAsset;
  ref: string;
}

export interface FileAsset {
  ref: string;
  value: FileAssetValue;
}

export interface FileAssetValue {
  url: string;
  size: number;
  extension: string;
  originalFilename: string;
}

export type SanityColorCode = {
  rgb: {
    r: number;
    g: number;
    b: number;
    a: number;
  };
  hex: string;
};

export enum SanityInformationKeys {
  PhoneHasDamage = 'PhoneHasDamage',
  WhatIsAnApprovedServicePoint = 'WhatIsAnApprovedServicePoint',
  HowToFindIMEI = 'HowToFindImei',
  DamageTypesDescriptions = 'DamageTypesDescriptions',
}
